import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Configuration from "../configuration";
var token = localStorage.getItem("x-access-token");

export const allProformaType = createAsyncThunk("proforma/allProformaType", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "proforma/allProformaType", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)
  });
  const proforma = await response.json();
  return proforma;
});

export const getProformaDate = createAsyncThunk("proforma/getProformaDate", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "proforma/getProformaDate", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)
  });
  const proforma = await response.json();
  return proforma;
});

export const proformaChangerEtat = createAsyncThunk("proforma/changerEtat", async (id) => {
  const response = await fetch(Configuration.BACK_BASEURL + "proforma/changerEtat/" + id, {
    method: 'PUT',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
  });
  const status = await response.status;
  return status;
});

export const saveImageProforma = createAsyncThunk("proforma/saveImageProforma", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "proforma/saveImageProforma", {
    method: 'POST',
    headers: {
      'Accept': 'application/*',
      'x-access-token': token,
    },
    body: action
  });
  const proforma = await response.json();
  return proforma;
});
export const fetchProforma = createAsyncThunk("proforma/fetchProforma", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "proforma/allProforma", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)
  });
  const proforma = await response.json();
  return proforma;
});

export const fetchProformaAfc = createAsyncThunk("proforma/fetchProformaAfc", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "proforma/allProformaAfc", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)
  });
  const proforma = await response.json();
  return proforma;
});

export const allProformaApp = createAsyncThunk("proforma/allProformaApp", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "proforma/allProformaApp", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)

  });
  const proforma = await response.json();
  return proforma;
});

export const proformaAdded = createAsyncThunk("proforma/addProforma", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "proforma/addProforma", {
   method: 'POST',
    headers: {
      'Accept': 'application/*',
      'x-access-token': token,
    },
    body: action
  });

  const proforma = await response.json();
  return proforma;
});

export const proformaDeleted = createAsyncThunk("proforma/delete", async (id) => {
  const response = await fetch(Configuration.BACK_BASEURL + "proforma/delete/" + id, {
    method: "delete",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-access-token": token,
    },
  });
  const reclamation = await response.json();
  return reclamation;
});

export const updateProforma = createAsyncThunk("proforma/updateProforma", async (data) => {
  const response = await fetch(Configuration.BACK_BASEURL + "proforma/updateProforma", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(data),
  });

  const proforma = await response.json();
  return proforma;
});

export const fetchProformaFour = createAsyncThunk("proforma/fetchProformaFour", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "proforma/fetchProformaFour", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action),

  });
  const proforma = await response.json();
  return proforma;
});
export const getProformaFour = createAsyncThunk("proforma/getProformaFour", async () => {
  const response = await fetch(Configuration.BACK_BASEURL + "proforma/getProformaFour", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },

  });
  const proforma = await response.json();
  return proforma;
});

export const proformaGetById = createAsyncThunk("proforma/proformaGetById", async (id1) => {
  const id = id1;
  const response = await fetch(Configuration.BACK_BASEURL + "proforma/getProforma", {
    method: 'POST',
    headers: {
      'id': id,
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },

  });
  const proforma = await response.json();
  return proforma;
});

export const proformaGetByIdDetails = createAsyncThunk("proforma/proformaGetByIdDetails", async (action) => {

  const response = await fetch(Configuration.BACK_BASEURL + "proforma/proformaGetByIdDetails", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action),

  });
  const proforma = await response.json();
  return proforma;
});

const proformaReduce = createSlice({
  name: "proforma",
  initialState: {
    entities: [],
    loading: false,
  },
  reducers: {



  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProforma.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(fetchProforma.fulfilled, (state, action) => {
        state.loading = false;
        state.entities = [...state.entities, ...action.payload];
      })
      .addCase(fetchProforma.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(proformaGetById.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(proformaGetById.fulfilled, (state, action) => {
        state.loading = false;
        state.entities = [...state.entities, action.payload];
      })
      .addCase(proformaGetById.rejected, (state, action) => {
        state.loading = false;
      });
  },

});
export default proformaReduce.reducer;
